import {callAPI} from '@/store/utils';

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    invoiceDetails: [],
  },
  getters: {
    getterInvoiceDetails(state) {
      return state.invoiceDetails;
    },
  },
  mutations: {
    setInvoiceDetails(state, data) {
      state.invoiceDetails = data;
    },
  },
  actions: {
    async actionGetInvoicesTemplate() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvoicesTemplate', {companyId});
      return res.result;
    },
    async actionAddManualInvoices(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'addManualInvoices',
        {...params, companyId},
        false,
        120,
        0,
      );
      return res;
    },
    async actionAddInvoicesViaPartner(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'uploadDocument',
        {...params, companyId},
        false,
        120,
        0,
      );
      return res;
    },
    async actionUploadInvoices(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'POST',
        'uploadInvoices',
        {...params, companyId},
        false,
        120,
        0,
      );
      return res;
    },
    async actionGetInvoicesHeaders(_, params) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvoicesHeaders', {
        ...params,
        companyId,
      });
      return res;
    },
    async actionCreateInvoice(_, invoice) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const copy = {...invoice, company_id: companyId};
      delete copy.needChangeETS;
      delete copy.ets;
      const res = await callAPI('POST', 'createInvoice', {
        invoice: copy,
        companyId,
      });
      return res;
    },
    async actionUpdateInvoice(_, invoice) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const should_invalidate_cache = invoice.should_invalidate_cache;
      const copy = {...invoice, company_id: companyId};
      delete copy.needChangeETS;
      delete copy.should_invalidate_cache;
      delete copy.ets;
      const req = {
        invoice: copy,
        companyId,
        ...(should_invalidate_cache !== null && {
          should_invalidate_cache,
        }),
      };
      const res = await callAPI('POST', 'updateInvoice', req);
      return res;
    },
    async actionPartialUpdateInvoice(_, invoice) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('PATCH', 'updateInvoices', {
        ...invoice,
        companyId,
      });
      return res;
    },
    async actionGetInvoices(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'listInvoices', {
        ...request,
        companyId,
      });
      return res.result;
    },
    async actionDeleteInvoice(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteInvoice', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionUpdateEngagedInvoices(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'updateEngagedInvoices', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionSetInvoicesCategory(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'setInvoicesCategory', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionCreateETS(_, ets) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const copy = {...ets};
      delete copy.ets_transactions;
      delete copy.newOne;
      delete copy.updatedOne;
      const res = await callAPI('POST', 'createETS', {ets: copy, companyId});
      return res;
    },
    async actionUpdateETS(_, ets) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const copy = {...ets};
      delete copy.etsTransactions;
      delete copy.newOne;
      delete copy.updatedOne;
      const res = await callAPI('POST', 'updateETS', {ets: copy, companyId});
      return res;
    },
    async actionDeleteETS(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteETS', {...request, companyId});
      return res;
    },
    async actionGetETS(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getETSByInvoiceId', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetInvoice(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvoice', {...request, companyId});
      return res.result;
    },
    async actionAttachTransaction(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'attachTransactionToETS', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionDetachTransaction(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'detachTransactionFromETS', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionCreateCheck(_, check) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const copy = {...check, company_id: companyId};
      delete copy.transaction;
      const res = await callAPI('POST', 'createBankCheck', {
        bank_check: copy,
        companyId,
      });
      return res;
    },
    async actionGetChecks(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'listBankChecks', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionUpdateCheck(_, check) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const copy = {...check};
      delete copy.transaction;
      const res = await callAPI('POST', 'updateBankCheck', {
        bank_check: copy,
        companyId,
      });
      return res;
    },
    async actionDeleteCheck(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'deleteBankCheck', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetETSByBankCheckId(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getETSByBankCheckId', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetInvoicesDetails(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getInvoicesDetails', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetBankChecksDetails(_, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('POST', 'getBankChecksDetails', {
        ...request,
        companyId,
      });
      return res;
    },
    async actionGetDetailsOfInvoiceETS({commit}, request) {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      commit('setInvoiceDetails', []);
      const res = await callAPI('POST', 'getDetailsOfInvoiceETS', {
        ...request,
        companyId,
      });
      if (res && !res.error) {
        commit('setInvoiceDetails', res?.result);
        return res?.result;
      }
      return res;
    },
  },
};
